module.exports = __webpack_public_path__ + "img/1678419206945-Sa0Itmjo.ca8e6043.png";